import { render, staticRenderFns } from "./transferProduct.vue?vue&type=template&id=795b3f89&scoped=true&"
import script from "./transferProduct.vue?vue&type=script&lang=js&"
export * from "./transferProduct.vue?vue&type=script&lang=js&"
import style0 from "./transferProduct.vue?vue&type=style&index=0&id=795b3f89&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795b3f89",
  null
  
)

export default component.exports